module.exports = __webpack_public_path__ + "img/play_store.d19abf33.png";